import { PieChart } from 'components/common/charts';
import { StatCount, StatItem } from 'components/common/stats';

import { StatCategory } from 'components/common/stats/StatCount';
import { PieChartData } from 'components/common/charts/PieChart';

interface Props {
  chartData: PieChartData;
  chartEmptyTooltip: string;
  chartId: string;
  chartLabel: string;
  statsPrimaryItem?: { label: string | React.ReactNode; value: number };
  statsSecondaryItems: {
    category?: StatCategory;
    label: string;
    value: number;
  }[];
}

const AnalyticsDataWithChart = ({
  chartData,
  chartEmptyTooltip,
  chartId,
  chartLabel,
  statsPrimaryItem,
  statsSecondaryItems
}: Props) => (
  <div className="data">
    <div className="stats">
      {statsPrimaryItem ? (
        <div className="stats-primary">
          <StatItem
            align="left"
            horizontal={true}
            small={true}
            label={statsPrimaryItem.label}
            value={statsPrimaryItem.value}
            valueStyle={{ minWidth: 40, paddingRight: 3, textAlign: 'right' }}
          />
        </div>
      ) : null}

      {statsSecondaryItems?.length
        ? statsSecondaryItems.map((item) => (
            <div className="stats-secondary" key={item.label}>
              <StatCount
                category={item.category || 'success-light'}
                label={item.label}
                value={item.value}
                valueStyle={{ minWidth: 40, textAlign: 'right' }}
              />
            </div>
          ))
        : null}
    </div>
    <div className="chart">
      <PieChart
        data={chartData}
        emptyTooltip={chartEmptyTooltip}
        id={chartId}
        label={chartLabel}
        showTooltip={true}
        style={{ width: '74px', height: '74px' }}
      />
    </div>

    <style jsx>{`
      .data {
        align-items: center;
        display: flex;
      }
      .stats {
        margin-right: 15px;
        flex-grow: 1;
        min-width: 0;
      }
      .stats-secondary {
        display: flex;
      }
      .stats-secondary:not(:first-child) {
        margin-top: 5px;
      }
    `}</style>
  </div>
);

export default AnalyticsDataWithChart;
